export default {
      id: "checkin-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.7315c2cd.svg#checkin",
      toString: function () {
        return this.url;
      }
    }